var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"text-center pa-6",attrs:{"rounded":_vm.isSmallerDisplay() ? '' : 'lg'}},[_c('div',{staticClass:"text-h4 mb-2"},[_vm._v(_vm._s(_vm.$t('message.page_not_found')))]),_c('div',{staticClass:"mb-2 mt-2"},[_c('IconLike',{staticClass:"rotate-90",attrs:{"size":"200px","color":_vm.themeColor('error')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }